import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';import { useSiteConfig, WidgetOperationTypes } from '@openedx/frontend-base';

const customApp: App = {
  appId: 'custom',
};const LimesFooter = () => {
  const config = useSiteConfig();
  const commonAppConfig = config.commonAppConfig ?? {};
  const logoStyle = { maxHeight: 45 };
  const logoUrl = (commonAppConfig.LOGO_TRADEMARK_URL as string | undefined)
    ?? config.headerLogoImageUrl
    ?? '/theming/asset/images/logo.png';

  return (
    <footer role="contentinfo" className="footer d-flex flex-column border-top py-3 px-4">
      <div className="d-flex justify-content-between">
        <nav className="navbar site-nav navbar-expand-sm" aria-label="About">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" target="_blank" rel="noopener noreferrer" href={`${config.lmsBaseUrl}/home/chisiamo`}>Chi siamo</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" target="_blank" rel="noopener noreferrer" href={`${config.lmsBaseUrl}/home/contatti`}>Contatti</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" target="_blank" rel="noopener noreferrer" href={`${config.lmsBaseUrl}/home/candidature`}>Informativa sulla privacy</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" target="_blank" rel="noopener noreferrer" href={`${config.lmsBaseUrl}/home/condizionidelservizio`}>Termini di servizio</a>
            </li>
          </ul>
        </nav>

        <div>
          <a href="https://openedx.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://openedx.org/wp-content/uploads/2025/08/openedx-logo-2026.svg" alt="openEdx" width="140" />
          </a>
        </div>
      </div>

      <div className="container-fluid">
        <div>
          <a className="d-block" href={config.lmsBaseUrl} aria-label="Limes home">
            <img style={logoStyle} src={logoUrl} alt={config.siteName} />
          </a>
        </div>

        <p className="copyright">
          © Limes. Tutti i diritti riservati eccetto dove indicato.
          edX, Open edX ed i rispettivi logo sono marchi registrati di edX Inc.
        </p>

      </div>
    </footer>
  );
};
addSlot(customApp, 
{
  slotId: 'org.openedx.frontend.slot.footer.main.v1',
  op: WidgetOperationTypes.REPLACE,
  id: 'org.openedx.frontend.widget.footer.limes.v1',
  relatedId: 'org.openedx.frontend.widget.footer.main.v1',
  element: <LimesFooter />,
}
);

export default customApp;